var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "700" },
      model: {
        value: _vm.downloadShareDialogVisible,
        callback: function ($$v) {
          _vm.downloadShareDialogVisible = $$v
        },
        expression: "downloadShareDialogVisible",
      },
    },
    [
      _c("customDialog", {
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(" " + _vm._s(_vm.tmb("titleShare")) + " "),
                _c("button", { attrs: { id: "dialog_exit" } }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/popup_close.png"),
                      id: "btn_img",
                    },
                    on: {
                      click: function ($event) {
                        _vm.downloadShareDialogVisible = false
                      },
                    },
                  }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "v-col",
                  { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "ma-0 pa-0 pt-5 pl-7 pr-7 content",
                        attrs: { cols: "12" },
                      },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "ma-0 pa-0 mb-4 text-left",
                            attrs: { cols: "12" },
                          },
                          [_vm._v(_vm._s(_vm.tmb("msgPublishShareLink")))]
                        ),
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0 mb-6",
                            attrs: { align: "center" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 text-left",
                                attrs: { cols: "2" },
                              },
                              [_vm._v(_vm._s(_vm.tmb("fileName")))]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 text-left",
                                attrs: { cols: "10" },
                              },
                              [_vm._v(_vm._s(_vm.item.name + ".mp4"))]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    !_vm.shareItemData.sharedLinkList ||
                    _vm.shareItemData.sharedLinkList.length === 0
                      ? _c(
                          "v-col",
                          {
                            staticClass: "ma-0 pa-0 pb-7 pl-7 pr-7 content",
                            attrs: { cols: "12" },
                          },
                          [
                            !_vm.fetchLoading
                              ? [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "ma-0 pa-0 mb-6",
                                      attrs: { align: "center" },
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0 text-left",
                                          attrs: { cols: "3" },
                                        },
                                        [_vm._v(_vm._s(_vm.tmb("numURLs")))]
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "2" },
                                        },
                                        [
                                          _c("v-select", {
                                            staticClass: "ma-0 pa-0",
                                            attrs: {
                                              "background-color": "#272727",
                                              dark: "",
                                              items: _vm.countNumList,
                                              dense: "",
                                              "hide-details": "",
                                              outlined: "",
                                            },
                                            model: {
                                              value: _vm.selectedLinkCount,
                                              callback: function ($$v) {
                                                _vm.selectedLinkCount = $$v
                                              },
                                              expression: "selectedLinkCount",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "ma-0 pa-0 mb-6",
                                      attrs: { align: "center" },
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass:
                                            "ma-0 pa-0 pr-2 text-left",
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.tmb("msgFiveDownload"))
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "ma-0 pa-0 pb-2",
                                      attrs: {
                                        align: "center",
                                        justify: "center",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "ma-0 pa-0 ml-2",
                                          attrs: {
                                            id: "blue_btn",
                                            width: "8rem",
                                            height: "2rem",
                                          },
                                          on: { click: _vm.generateFileURL },
                                        },
                                        [_vm._v(_vm._s(_vm.tmb("publishURLs")))]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _c(
                          "v-col",
                          {
                            staticClass: "ma-0 pa-0 pb-7 content",
                            attrs: { cols: "12" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass:
                                  "ma-0 pa-0 pt-2 pb-7 pl-7 pr-7 content",
                                attrs: { cols: "12" },
                              },
                              [
                                _vm._l(
                                  _vm.shareItemData.sharedLinkList,
                                  function (sharedLink, index) {
                                    return _c(
                                      "v-col",
                                      {
                                        key: index,
                                        staticClass: "ma-0 pa-0",
                                        attrs: { cols: "12" },
                                      },
                                      [
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "ma-0 pa-0 mb-3",
                                            attrs: { align: "center" },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass:
                                                  "ma-0 pa-0 text-left",
                                                attrs: { cols: "2" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.urlTitles[index])
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                ref: "urlLinkElement",
                                                refInFor: true,
                                                staticClass:
                                                  "ma-0 pa-0 text-left",
                                                attrs: { cols: "9" },
                                              },
                                              [
                                                _c("input", {
                                                  attrs: {
                                                    id: "urlText",
                                                    type: "text",
                                                    readonly: "",
                                                  },
                                                  domProps: {
                                                    value: sharedLink.url,
                                                  },
                                                }),
                                              ]
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0",
                                                attrs: { cols: "1" },
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "clipboard",
                                                        rawName: "v-clipboard",
                                                        value: sharedLink.url,
                                                        expression:
                                                          "sharedLink.url",
                                                      },
                                                      {
                                                        name: "clipboard",
                                                        rawName:
                                                          "v-clipboard:success",
                                                        value:
                                                          _vm.clipboardSuccessHandler,
                                                        expression:
                                                          "clipboardSuccessHandler",
                                                        arg: "success",
                                                      },
                                                      {
                                                        name: "clipboard",
                                                        rawName:
                                                          "v-clipboard:error",
                                                        value:
                                                          _vm.clipboardErrorHandler,
                                                        expression:
                                                          "clipboardErrorHandler",
                                                        arg: "error",
                                                      },
                                                    ],
                                                    staticClass: "ma-0 pa-0",
                                                    attrs: {
                                                      id: "back_clean_btn",
                                                      width: "1rem",
                                                      height: "1rem",
                                                      elevation: "0",
                                                    },
                                                  },
                                                  [
                                                    _c("v-img", {
                                                      staticClass: "ma-0 pa-0",
                                                      attrs: {
                                                        "max-height": "2rem",
                                                        "max-width": "2rem",
                                                        src: require("@/assets/images/icon_copy.png"),
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "ma-0 pa-0 mb-3",
                                            attrs: { align: "center" },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass:
                                                  "ma-0 pa-0 text-left",
                                                attrs: { cols: "2" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.tmb("titleStatus"))
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass:
                                                  "ma-0 pa-0 text-left",
                                                attrs: { cols: "3" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getLinkStatus(index)
                                                  )
                                                ),
                                              ]
                                            ),
                                            sharedLink.status === "CREATED"
                                              ? _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "ma-0 pa-0",
                                                    attrs: { cols: "2" },
                                                  },
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          id: "blue_btn",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.invalidateURL(
                                                              index
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.tmb(
                                                              "invalidateURL"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                _c(
                                  "v-col",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isAllInvalid,
                                        expression: "isAllInvalid",
                                      },
                                    ],
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          id: "blue_btn",
                                          elevation: "0",
                                        },
                                        on: { click: _vm.confirmInitialize },
                                      },
                                      [_vm._v(_vm._s(_vm.tmb("republishURLs")))]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              2
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 text-left",
                                attrs: { cols: "12" },
                              },
                              [_vm._v(_vm._s(_vm.tmb("msgInvalidatedButton")))]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 text-left",
                                attrs: { cols: "12" },
                              },
                              [_vm._v(_vm._s(_vm.tmb("msgOnceDownload")))]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 text-left",
                                attrs: { cols: "12" },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.tmb("msgAllDownloadRepublish"))
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }